// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  justify-content: center;
}

.nav-card-link {
  text-decoration: none;
}

.nav-card {
  position: relative;
  border: 1px solid var(--color-border);
  border-radius: 12px;
  overflow: hidden;
  background: #ffffff;
  transition: transform 0.15s ease, box-shadow 0.2s ease, border-color 0.2s ease;
  box-shadow: 0 2px 10px rgba(2, 6, 12, 0.04);
  width: 260px;
}

.nav-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 24px rgba(2, 12, 6, 0.08);
  border-color: rgba(22, 163, 74, 0.35);
}

.nav-card__media {
  height: 160px;
  background: linear-gradient(135deg, rgba(34,197,94,0.2), rgba(22,163,74,0.3));
  display: block;
}
.nav-card__media img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.nav-card__name {
  padding: 12px 14px;
  font-weight: 700;
  color: var(--color-text);
  border-top: 1px solid var(--color-border);
  text-align: center;
  font-size: 16px;
}

/* Mobile: two columns, centered last item */
@media (max-width: 430px) {
  .card-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
    justify-items: center;
  }
  
  /* When there's an odd number of items, center the last item across both columns */
  .card-grid .nav-card-link:last-child:nth-child(odd) {
    grid-column: 1 / -1;
    justify-self: center;
  }
  
  .nav-card {
    width: 100%;
    max-width: 180px;
    min-width: 160px;
  }
  .nav-card__media {
    height: 120px;
  }
  .nav-card__name {
    font-size: 14px;
    padding: 10px 12px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/NavCard.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,8EAA8E;EAC9E,2CAA2C;EAC3C,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;EAC5C,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,6EAA6E;EAC7E,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,yCAAyC;EACzC,kBAAkB;EAClB,eAAe;AACjB;;AAEA,4CAA4C;AAC5C;EACE;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,qBAAqB;EACvB;;EAEA,kFAAkF;EAClF;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;AACF","sourcesContent":[".card-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n  justify-content: center;\n}\n\n.nav-card-link {\n  text-decoration: none;\n}\n\n.nav-card {\n  position: relative;\n  border: 1px solid var(--color-border);\n  border-radius: 12px;\n  overflow: hidden;\n  background: #ffffff;\n  transition: transform 0.15s ease, box-shadow 0.2s ease, border-color 0.2s ease;\n  box-shadow: 0 2px 10px rgba(2, 6, 12, 0.04);\n  width: 260px;\n}\n\n.nav-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 10px 24px rgba(2, 12, 6, 0.08);\n  border-color: rgba(22, 163, 74, 0.35);\n}\n\n.nav-card__media {\n  height: 160px;\n  background: linear-gradient(135deg, rgba(34,197,94,0.2), rgba(22,163,74,0.3));\n  display: block;\n}\n.nav-card__media img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.nav-card__name {\n  padding: 12px 14px;\n  font-weight: 700;\n  color: var(--color-text);\n  border-top: 1px solid var(--color-border);\n  text-align: center;\n  font-size: 16px;\n}\n\n/* Mobile: two columns, centered last item */\n@media (max-width: 430px) {\n  .card-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 12px;\n    justify-items: center;\n  }\n  \n  /* When there's an odd number of items, center the last item across both columns */\n  .card-grid .nav-card-link:last-child:nth-child(odd) {\n    grid-column: 1 / -1;\n    justify-self: center;\n  }\n  \n  .nav-card {\n    width: 100%;\n    max-width: 180px;\n    min-width: 160px;\n  }\n  .nav-card__media {\n    height: 120px;\n  }\n  .nav-card__name {\n    font-size: 14px;\n    padding: 10px 12px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
